import { useEffect, useState } from "react";
import {
    Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography,
} from "@mui/material";
import { Block, LockOpen } from "@mui/icons-material";

interface IModalBloqueioProps {
    open: boolean;
    /** true = bloquear; false = liberar de volta. */
    bloquear: boolean;
    nomeEstabelecimento: string;
    loading?: boolean;
    onConfirmar: (motivo?: string) => void;
    onFechar: () => void;
}

export const ModalBloqueio = ({ open, bloquear, nomeEstabelecimento, loading, onConfirmar, onFechar }: IModalBloqueioProps) => {
    const [motivo, setMotivo] = useState("");

    useEffect(() => {
        if (open) {
            setMotivo("");
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={onFechar} fullWidth maxWidth="sm">
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {bloquear ? <Block color="error" /> : <LockOpen color="success" />}
                {bloquear ? "Bloquear acesso" : "Liberar acesso"}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {bloquear
                        ? `Ninguém conseguirá entrar em ${nomeEstabelecimento} enquanto o bloqueio estiver ativo — nem os usuários do estabelecimento, nem os membros da organização. Os dados são preservados e o bloqueio pode ser revertido a qualquer momento.`
                        : `Os usuários voltarão a entrar em ${nomeEstabelecimento} normalmente.`}
                </Typography>

                {bloquear && (
                    <>
                        <TextField
                            label="Motivo (opcional)"
                            placeholder="Ex.: pagamento em atraso"
                            fullWidth
                            size="small"
                            value={motivo}
                            onChange={(event) => setMotivo(event.target.value)}
                            inputProps={{ maxLength: 255 }}
                        />
                        <Alert severity="info" sx={{ mt: 2 }}>
                            O motivo é exibido para quem tentar entrar no estabelecimento.
                        </Alert>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onFechar}>Cancelar</Button>
                {loading ? (
                    <CircularProgress size={24} sx={{ mx: 2 }} />
                ) : (
                    <Button
                        variant="contained"
                        color={bloquear ? "error" : "success"}
                        onClick={() => onConfirmar(motivo.trim() || undefined)}
                    >
                        {bloquear ? "Bloquear acesso" : "Liberar acesso"}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
